import {Link} from "../Link";
import {useTranslation} from "react-i18next";
import type { I18NLinkProps } from "./I18NLink.interface.ts";

/**
 * Primary UI component for user interaction
 */
export function I18NLink(props: I18NLinkProps) {

  const {t} = useTranslation();

  return (<Link {...props} text={t(props.i18n)}  />);
}
